import { OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { SidebarService } from '@ibe.components/common/sidebar/sidebar.service';
import { Store } from '@ngrx/store';
import { takeWhile } from 'rxjs/operators';
import * as fromStore from '../../../../store/index';
import { Router, ActivatedRoute } from '@angular/router';
import { BookedTrip } from '@ibe/models';
import { BookingStep } from '@ibe/models/ui';
import * as BookedTripActions from '@ibe/store/actions/booked-trip.actions';
import * as ConfirmModalActions from '@ibe/store/actions/confirm-modal.actions';
import { INDRAConfirmModalComponent } from '@ibe.components/shared/confirm-modal/confirm-modal.indra.component';
import { ModalService } from '@ibe/services/ui';
import * as AncillariesWithMilesActions from '@ibe/store/actions/ancillaries-with-miles.actions';
import * as BookingStepsActions from '@ibe/store/actions/booking-steps.actions';
import { LOCAL_STORAGE_VAR_KEY_ROUTE_NAME, LOCAL_STORAGE_VAR_KEY_DONT_REDIRECT, TRIP_TYPE_MULTICITY_CODE, } from '@ibe.config';
import * as MiniIBEActions from '@ibe/store/actions/mini-ibe.actions';
import * as FlightInformationActions from '@ibe/store/actions/flight-information.indra.actions';
import * as OutboundFlightInformationActions from '@ibe/store/actions/outbound-flight-information.indra.actions';
import * as InboundFlightInformationActions from '@ibe/store/actions/inbound-flight-information.indra.actions';
var steps;
(function (steps) {
    steps[steps["dates"] = 1] = "dates";
    steps[steps["flights"] = 2] = "flights";
    steps[steps["review"] = 3] = "review";
    steps[steps["extras"] = 4] = "extras";
    steps[steps["payment"] = 5] = "payment";
})(steps || (steps = {}));
;
var stepsForMCOrStopover;
(function (stepsForMCOrStopover) {
    stepsForMCOrStopover[stepsForMCOrStopover["flights"] = 1] = "flights";
    stepsForMCOrStopover[stepsForMCOrStopover["review"] = 2] = "review";
    stepsForMCOrStopover[stepsForMCOrStopover["payment"] = 3] = "payment";
})(stepsForMCOrStopover || (stepsForMCOrStopover = {}));
;
var INDRATopMenuBarComponent = /** @class */ (function () {
    function INDRATopMenuBarComponent(sidebarService, store, router, route, modalService) {
        var _this = this;
        this.sidebarService = sidebarService;
        this.store = store;
        this.router = router;
        this.route = route;
        this.modalService = modalService;
        this.isBack = true;
        this.returnToSearch = false;
        this.backPage = new EventEmitter();
        this.refresh = new EventEmitter();
        this.newSearch = new EventEmitter();
        this.bookedTrip$ = this.store.select(fromStore.getSelectedBookedTrip);
        this.isCorporate$ = this.store.select(fromStore.getIsCorporate);
        this.stopovers$ = this.store.select(fromStore.getMiniIBEStopovers);
        this.isStopover = false;
        this.booking_type$ = this.store.select(fromStore.getSelectedBookingType);
        this.bookingSteps$ = this.store.select(fromStore.getSelectedBookingSteps);
        this.bookingSteps = [];
        this.confirmModalCallback$ = this.store.select(fromStore.getConfirmModalConfirm);
        this.confirmModalCallback = '';
        this.current_page$ = this.store.select(fromStore.getSelectedBookingCurrentPage);
        this.timeToThink_to_booking$ = this.store.select(fromStore.getSelectedBookedTripTTTCompletionDetails);
        this.isTTTBookingPayment = false;
        this.actionsOpen = false;
        this.IsMulticity = false;
        this.isAlive = true;
        this.menuItems = [];
        router.events
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (event) {
            if (event.navigationTrigger === 'popstate') {
                if (!_this.isBack) {
                    var returnRef = '/' + _this.router.url.split('/')[1];
                    _this.sidebarService.close();
                    _this.store.dispatch(new MiniIBEActions.Reset());
                    _this.store.dispatch(new BookingStepsActions.ResetAction());
                    _this.router.navigate([returnRef]);
                }
                else {
                    _this.sidebarService.close();
                    _this.INDRA_handleBackButton();
                }
            }
        });
    }
    INDRATopMenuBarComponent.prototype.ngOnDestroy = function () {
        window.removeEventListener('beforeunload', this.beforeUnloadHandler.bind(this));
        this.isAlive = false;
    };
    INDRATopMenuBarComponent.prototype.ngOnInit = function () {
        var _this = this;
        window.addEventListener('beforeunload', this.beforeUnloadHandler.bind(this));
        this.timeToThink_to_booking$.pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                _this.isTTTBookingPayment = true;
            }
        });
        this.booking_type$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.IsMulticity = value == TRIP_TYPE_MULTICITY_CODE;
        });
        this.bookedTrip$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                _this.booking = value;
            }
        });
        this.isCorporate$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.isCorporate = value;
        });
        this.stopovers$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                _this.isStopover = value.length > 0;
            }
        });
        this.confirmModalCallback$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                _this.confirmModalCallback = value;
            }
        });
        this.current_page$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.current_page = value;
        });
        this.bookingSteps$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) { return _this.bookingStepsValue = value; });
        this.currentStep = this.INDRA_getStep(this.router.url);
        this.menuItems = this.INDRA_menuItems();
    };
    INDRATopMenuBarComponent.prototype.INDRA_getStep = function (url) {
        var isMultiOrStop = this.IsMulticity || this.isStopover;
        var stepsToUse = isMultiOrStop ? stepsForMCOrStopover : steps;
        if (url.includes('/dates') && !isMultiOrStop)
            return steps.dates;
        if (url.includes('/flights'))
            return stepsToUse.flights;
        if (url.includes('/review-your-trip'))
            return stepsToUse.review;
        if (url.includes('/extras-to-your-trip')) {
            return isMultiOrStop ? stepsToUse.review : steps.extras;
        }
        if (url.includes('/payment'))
            return stepsToUse.payment;
    };
    INDRATopMenuBarComponent.prototype.INDRA_menuItems = function () {
        var menuItems = [];
        var MCorStopover = this.IsMulticity || this.isStopover;
        if (this.INDRA_showDate && !MCorStopover) {
            menuItems.push({
                id: 'menu_btn_dates',
                translationKey: 'header.text.dates',
            });
        }
        var menuItemsToAdd = [
            {
                id: 'menu_btn_flights',
                translationKey: 'header.text.flights',
            },
            {
                id: 'menu_btn_review',
                translationKey: 'header.text.review',
            }
        ].concat((MCorStopover ? [] : [{
                id: 'menu_btn_extras',
                translationKey: 'header.text.extras',
            }]), [
            {
                id: 'menu_btn_payment',
                translationKey: 'header.text.payment',
            }
        ]);
        menuItems.push.apply(menuItems, menuItemsToAdd);
        return menuItems;
    };
    INDRATopMenuBarComponent.prototype.INDRA_handleActionBtn = function (id) {
        var step = this.INDRA_getStepbyId(id);
        if (this.IsMulticity || this.isStopover) {
            var stepsToUse = stepsForMCOrStopover;
            switch (step) {
                case (stepsToUse.flights):
                    { //Heading to Flights from...
                        if (this.currentStep >= stepsToUse.review) {
                            this.store.dispatch(new FlightInformationActions.ResetAction);
                            this.store.dispatch(new OutboundFlightInformationActions.ResetOutboundFlightInformationAction);
                            this.store.dispatch(new InboundFlightInformationActions.ResetInboundFlightInformationAction);
                            if (this.returnToSearch && this.currentStep == stepsToUse.review) {
                                this.newSearch.emit();
                            }
                            else {
                                this.backPage.emit('flights');
                            }
                            //this.INDRA_handleReviewBack2Flights();
                        }
                        break;
                    }
                    ;
                case (stepsToUse.review):
                    { //Heading to Review from...
                        if (this.currentStep >= stepsToUse.review) {
                            sessionStorage.setItem('previousStep', this.current_page);
                            this.router.navigate(['/booking/review-your-trip']);
                        }
                        break;
                    }
                    ;
                default:
                    {
                        this.router.navigate(['/booking/']);
                        break;
                    }
                    ;
            }
        }
        else {
            var stepsToUse = steps;
            switch (step) {
                case (stepsToUse.dates):
                    { //Heading to Dates from...
                        if (this.IsMulticity || this.isStopover) {
                            this.store.dispatch(new FlightInformationActions.ResetAction);
                            this.store.dispatch(new OutboundFlightInformationActions.ResetOutboundFlightInformationAction);
                            this.store.dispatch(new InboundFlightInformationActions.ResetInboundFlightInformationAction);
                            this.router.navigate(['/booking']);
                        }
                        else if (this.currentStep == stepsToUse.flights) {
                            this.store.dispatch(new FlightInformationActions.ResetAction);
                            this.store.dispatch(new OutboundFlightInformationActions.ResetOutboundFlightInformationAction);
                            this.store.dispatch(new InboundFlightInformationActions.ResetInboundFlightInformationAction);
                            this.router.navigate(['/booking/dates'], { queryParams: { confirm: 'flights' } });
                        }
                        else if (this.currentStep >= stepsToUse.review) {
                            this.store.dispatch(new FlightInformationActions.ResetAction);
                            this.store.dispatch(new OutboundFlightInformationActions.ResetOutboundFlightInformationAction);
                            this.store.dispatch(new InboundFlightInformationActions.ResetInboundFlightInformationAction);
                            this.INDRA_handleReviewBack2Dates();
                        }
                        break;
                    }
                    ;
                case (stepsToUse.flights):
                    { //Heading to Flights from...
                        if (this.currentStep >= stepsToUse.review) {
                            this.store.dispatch(new FlightInformationActions.ResetAction);
                            this.store.dispatch(new OutboundFlightInformationActions.ResetOutboundFlightInformationAction);
                            this.store.dispatch(new InboundFlightInformationActions.ResetInboundFlightInformationAction);
                            if (this.returnToSearch && this.currentStep == stepsToUse.review) {
                                this.newSearch.emit();
                            }
                            else {
                                this.backPage.emit('flights');
                            }
                            //this.INDRA_handleReviewBack2Flights();
                        }
                        break;
                    }
                    ;
                case (stepsToUse.review):
                    { //Heading to Review from...
                        if (this.currentStep >= steps.extras) {
                            sessionStorage.setItem('previousStep', this.current_page);
                            this.router.navigate(['/booking/review-your-trip']);
                        }
                        break;
                    }
                    ;
                case (steps.extras):
                    { //Heading to Extras from...
                        if (!this.isTTTBookingPayment) {
                            this.router.navigate(['/booking/extras-to-your-trip']);
                        }
                        else {
                            this.router.navigate(['/booking/time-to-think']);
                        }
                        break;
                    }
                    ;
                default:
                    {
                        this.router.navigate(['/booking/']);
                        break;
                    }
                    ;
            }
        }
    };
    INDRATopMenuBarComponent.prototype.INDRA_buttonStyle = function (id) {
        var step = this.INDRA_getStepbyId(id);
        var classes = [];
        if (this.currentStep < step)
            classes.push('disable');
        if (this.currentStep == step)
            classes.push('is-selected');
        return classes;
    };
    INDRATopMenuBarComponent.prototype.INDRA_getStepbyId = function (id) {
        var step;
        if (this.IsMulticity || this.isStopover) {
            var stepsToUse = stepsForMCOrStopover;
            step = stepsToUse.flights;
            switch (id) {
                case 'menu_btn_flights': {
                    step = stepsToUse.flights;
                    break;
                }
                case 'menu_btn_review': {
                    step = stepsToUse.review;
                    break;
                }
                case 'menu_btn_payment': {
                    step = stepsToUse.payment;
                    break;
                }
                default: {
                    step = stepsToUse.flights;
                    break;
                }
            }
            ;
        }
        else {
            var stepsToUse = steps;
            step = stepsToUse.dates;
            switch (id) {
                case 'menu_btn_dates': {
                    step = stepsToUse.dates;
                    break;
                }
                case 'menu_btn_flights': {
                    step = stepsToUse.flights;
                    break;
                }
                case 'menu_btn_review': {
                    step = stepsToUse.review;
                    break;
                }
                case 'menu_btn_extras': {
                    step = steps.extras;
                    break;
                }
                case 'menu_btn_payment': {
                    step = stepsToUse.payment;
                    break;
                }
                default: {
                    step = stepsToUse.dates;
                    break;
                }
            }
            ;
        }
        return step;
    };
    INDRATopMenuBarComponent.prototype.INDRA_getIdBtStep = function (currentStep) {
        var id = 'menu_btn_dates';
        switch (currentStep) {
            case steps.dates: {
                id = 'menu_btn_dates';
                break;
            }
            case steps.flights: {
                id = 'menu_btn_flights';
                break;
            }
            case steps.review: {
                id = 'menu_btn_review';
                break;
            }
            case steps.extras: {
                id = 'menu_btn_extras';
                break;
            }
            case steps.payment: {
                id = 'menu_btn_payment';
                break;
            }
            default: {
                id = 'menu_btn_dates';
                break;
            }
        }
        ;
        return id;
    };
    INDRATopMenuBarComponent.prototype.INDRA_handleReviewBack2Dates = function () {
        var _this = this;
        this.store.dispatch(new ConfirmModalActions.PutTitle('Back to dates selection'));
        this.store.dispatch(new ConfirmModalActions.PutBodyMsg('If you choose to continue, you will loose the flight(s) you have selected. You will have to select all flights again. Are you sure you want to leave this page?'));
        this.store.dispatch(new ConfirmModalActions.PutCancelLabel('Don´t leave this page'));
        this.store.dispatch(new ConfirmModalActions.PutOkLabel('Choose dates again'));
        this.modalService.assignComponent(INDRAConfirmModalComponent);
        this.modalService.open();
        this.modalService.isOpen
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (!value) {
                if (_this.confirmModalCallback === 'ok') {
                    _this.router.navigate(['/booking/dates'], { queryParams: { confirm: 'flights' } });
                }
            }
        });
    };
    INDRATopMenuBarComponent.prototype.INDRA_handleReviewBack2Flights = function () {
        var _this = this;
        this.store.dispatch(new ConfirmModalActions.PutTitle('Back to flight selection'));
        this.store.dispatch(new ConfirmModalActions.PutBodyMsg('If you choose to continue, you will loose the flight(s) you have selected. You will have to select all flights again. Are you sure you want to leave this page?'));
        this.store.dispatch(new ConfirmModalActions.PutCancelLabel('Don´t leave this page'));
        this.store.dispatch(new ConfirmModalActions.PutOkLabel('Choose flights again'));
        this.modalService.assignComponent(INDRAConfirmModalComponent);
        this.modalService.open();
        this.modalService.isOpen
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (!value) {
                if (_this.confirmModalCallback === 'ok') {
                    _this.INDRA_clearBookedTrip();
                    _this.store.dispatch(new AncillariesWithMilesActions.ResetAction());
                    _this.store.dispatch(new ConfirmModalActions.ResetAction);
                    if (_this.booking.stopover) {
                        _this.router.navigate(['/booking/flights-stopover']);
                    }
                    else {
                        if (_this.booking.booking_type == 'M') {
                            _this.router.navigate(['/booking/flights-multicity']);
                        }
                        else {
                            _this.router.navigate(['/booking/flights']);
                        }
                    }
                }
            }
        });
    };
    INDRATopMenuBarComponent.prototype.INDRA_clearBookedTrip = function () {
        var auxArray = [];
        this.bookingSteps.forEach(function (step) { auxArray.push(Object.assign(new BookingStep(null, null), step, { flight_selected: false })); });
        var booked_trips = Object.assign(new BookedTrip([], this.booking.pnr, this.booking.booking_type), this.booking, { is_time_to_think: false });
        booked_trips.emptyFlights();
        this.store.dispatch(new BookedTripActions.PutBookedTripAction(booked_trips));
        this.store.dispatch(new BookingStepsActions.PutStepsAction(auxArray));
        this.store.dispatch(new BookingStepsActions.PutCurrentStepAction(0));
    };
    INDRATopMenuBarComponent.prototype.INDRA_lockNextBtns = function (id) {
        var step = this.INDRA_getStepbyId(id);
        return this.currentStep < step;
    };
    INDRATopMenuBarComponent.prototype.INDRA_showOrder = function (id) {
        var step = this.INDRA_getStepbyId(id);
        return this.INDRA_showDate() ? step : step;
    };
    INDRATopMenuBarComponent.prototype.INDRA_showDate = function () {
        return !this.isCorporate && !this.isStopover && !this.IsMulticity;
    };
    /**
     * Emit back event to parent
     */
    INDRATopMenuBarComponent.prototype.INDRA_handleBackButton = function () {
        var _this = this;
        var currentStepId = this.INDRA_getIdBtStep(this.currentStep);
        if (currentStepId) {
            // Special case for flights to check if user didnt go through dates page
            if (currentStepId === 'menu_btn_flights') {
                this.bookingStepsValue.map(function (data) {
                    if (data.date_selected) {
                        _this.INDRA_handleActionBtn('menu_btn_dates');
                    }
                    else {
                        _this.store.dispatch(new FlightInformationActions.ResetAction);
                        _this.store.dispatch(new OutboundFlightInformationActions.ResetOutboundFlightInformationAction);
                        _this.store.dispatch(new InboundFlightInformationActions.ResetInboundFlightInformationAction);
                        _this.backPage.emit();
                    }
                });
            }
            else {
                var menuItems = this.INDRA_menuItems();
                var currentStepIndex = menuItems.findIndex(function (item) { return item.id === currentStepId; });
                if (currentStepIndex > 0) {
                    var previousMenuItem = menuItems[currentStepIndex - 1];
                    if (previousMenuItem) {
                        this.INDRA_handleActionBtn(previousMenuItem.id);
                    }
                }
            }
        }
        else {
            if (this.returnToSearch) {
                this.newSearch.emit();
            }
            else {
                this.backPage.emit();
            }
        }
    };
    INDRATopMenuBarComponent.prototype.beforeUnloadHandler = function (event) {
        localStorage.setItem(LOCAL_STORAGE_VAR_KEY_DONT_REDIRECT, 'true');
        localStorage.setItem(LOCAL_STORAGE_VAR_KEY_ROUTE_NAME, this.router.url);
        this.sidebarService.close();
        this.refresh.emit();
    };
    return INDRATopMenuBarComponent;
}());
export { INDRATopMenuBarComponent };
